import { render } from "./CasinoLiveComponent.vue?vue&type=template&id=60dcc99c&scoped=true&ts=true"
import script from "./CasinoLiveComponent.vue?vue&type=script&lang=ts"
export * from "./CasinoLiveComponent.vue?vue&type=script&lang=ts"

import "./CasinoLiveComponent.vue?vue&type=style&index=0&id=60dcc99c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60dcc99c"]])

export default __exports__